import { render } from "./NavbarComponent.vue?vue&type=template&id=4fbd6139&scoped=true"
const script = {}

import "./NavbarComponent.vue?vue&type=style&index=0&id=4fbd6139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbd6139"]])

export default __exports__